import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import useAppContext from "../hooks/useAppContext";
import { AppContextType } from "../context/AppContext";
import { getUserDetails } from "../services/User_service";

const API_URL = process.env.REACT_APP_API_URL;

const AnonymousLogin = () => {
  const navigate = useNavigate();
  const { setUserName, setUserFirstname, setUserStatus } = useAppContext() as AppContextType;
  const hasShownMessage = useRef(false);

  const handleAnonymousLogin = async () => {
    try {
      const response = await axios.post(`${API_URL}/user/anonymous`);
      console.log("✅ Réponse reçue du backend:", response);

      if (
        (response.status === 200 || response.status === 201) &&
        response.data.token &&
        response.data.user
      ) {
        const { token, user } = response.data;

        if (!user?.id) {
          console.error("❌ ID utilisateur manquant");
          if (!hasShownMessage.current) {
            hasShownMessage.current = true;
          }
          return;
        }

        localStorage.setItem("token", token);
        localStorage.setItem("userId", user.id.toString());
        localStorage.setItem("role", user.role || "");
        localStorage.setItem("username", `${user.firstname || ""} ${user.name || ""}`);
        localStorage.setItem("userFirstname", user.firstname || "");
        localStorage.setItem("userName", user.name || user.username || "");
        localStorage.setItem("userEmail", user.email || "");
        localStorage.setItem("userStatus", user.status);

        setUserFirstname(user.firstname || "");
        setUserName(user.name || user.username || "");
        setUserStatus(user.status);

        if (!hasShownMessage.current) {
          console.log("✅ Connexion anonyme réussie !");
          hasShownMessage.current = true;
        }

        await getUserDetails();

        // ── Vérifier si une destination externe a été stockée ──────
        const stored = sessionStorage.getItem("postLoginRedirect");
        if (stored) {
          sessionStorage.removeItem("postLoginRedirect");
          const { path, state } = JSON.parse(stored);
          navigate(path, { replace: true, state });
        } else {
          navigate("/home", { replace: true });
        }

      } else {
        console.warn("❌ Données invalides reçues :", response.data);
        if (!hasShownMessage.current) {
          console.error("Connexion anonyme échouée");
          hasShownMessage.current = true;
        }
      }
    } catch (error: any) {
      console.error("❌ Erreur lors de la connexion anonyme :", error);

      if (!hasShownMessage.current) {
        console.error("Erreur lors de la connexion anonyme");
        hasShownMessage.current = true;

        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
    }
  };

  useEffect(() => {
    handleAnonymousLogin();
  }, []);

  return (
    <div className="div-spinner">
      <div className="spinner-square">
        <div className="square-1 square"></div>
        <div className="square-2 square"></div>
        <div className="square-3 square"></div>
      </div>
    </div>
  );
};

export default AnonymousLogin;